var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5312 19.6688C23.8312 19.9688 23.9997 20.3757 23.9997 20.8C23.9997 21.2243 23.8312 21.6312 23.5312 21.9312L17.1312 28.3312C16.8312 28.6312 16.4243 28.7997 16 28.7997C15.5757 28.7997 15.1689 28.6312 14.8688 28.3312L8.46881 21.9312C8.31599 21.7836 8.1941 21.6071 8.11025 21.4118C8.02639 21.2166 7.98225 21.0067 7.98041 20.7942C7.97856 20.5818 8.01904 20.3711 8.09949 20.1745C8.17994 19.9778 8.29875 19.7992 8.44898 19.649C8.5992 19.4987 8.77785 19.3799 8.97448 19.2995C9.17112 19.219 9.3818 19.1786 9.59425 19.1804C9.8067 19.1822 10.0166 19.2264 10.2119 19.3102C10.4071 19.3941 10.5836 19.516 10.7312 19.6688L14.4 23.3376V4.8C14.4 4.37565 14.5686 3.96869 14.8686 3.66863C15.1687 3.36857 15.5757 3.2 16 3.2C16.4244 3.2 16.8313 3.36857 17.1314 3.66863C17.4314 3.96869 17.6 4.37565 17.6 4.8V23.3376L21.2688 19.6688C21.5689 19.3688 21.9757 19.2003 22.4 19.2003C22.8243 19.2003 23.2312 19.3688 23.5312 19.6688V19.6688Z",
    fill: "#982C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowDown);
export default __webpack_public_path__ + "static/media/ico-arrow-down.9871633242206557be312f680a0d63c5.svg";
export { ForwardRef as ReactComponent };